<h4
  id="{{ baseId }}-name-details-subtitle"
  translate
>Name Details</h4>

<section class="flex-row-generic" [formGroup]="form">
  <!-- Title Control -->
  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-title"
      translate
    >Title</label>
    <input
      id="{{ baseId }}-title"
      class="form-control"
      [ngClass]="{ error: showErrors(titleControl, isSubmitted), 'required': isRequired(titleControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.Prefix.MaxLength"
      formControlName="title"
    />
    <div
      *ngIf="showErrors(titleControl, isSubmitted)"
      id="{{ baseId }}-warning-text-title"
      class="incorrect-input"
      translate
    >
      {{ titleControl.errors | fcListValidation : 'Title' }}
    </div>
  </div>
  <!-- Title Control -->

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-first-name"
      translate
    >First Name</label>
    <input
      id="{{ baseId }}-first-name"
      class="form-control"
      [ngClass]="{ error: showErrors(firstNameControl, isSubmitted), 'required': isRequired(firstNameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.FirstName.MaxLength"
      formControlName="firstName"
    />
    <div
      *ngIf="showErrors(firstNameControl, isSubmitted)"
      id="{{ baseId }}-warning-text-first-name"
      class="incorrect-input"
      translate
    >
      {{ firstNameControl.errors | fcListValidation : 'First Name' }}
    </div>
  </div>

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-middle-name"
      translate
    >Middle Name</label>
    <input
      id="{{ baseId }}-middle-name"
      class="form-control"
      [ngClass]="{ error: showErrors(middleNameControl, isSubmitted), 'required': isRequired(middleNameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.MiddleName.MaxLength"
      formControlName="middleName"
    />
    <div
      *ngIf="showErrors(middleNameControl, isSubmitted)"
      id="{{ baseId }}-warning-text-middle-name"
      class="incorrect-input"
      translate
    >
      {{ middleNameControl.errors | fcListValidation : 'Middle Name' }}
    </div>
  </div>

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-last-name"
      translate
    >Last Name</label>
    <input
      id="{{ baseId }}-last-name"
      class="form-control"
      [ngClass]="{ error: showErrors(lastNameControl, isSubmitted), 'required': isRequired(lastNameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.LastName.MaxLength"
      formControlName="lastName"
    />
    <div
      *ngIf="showErrors(lastNameControl, isSubmitted)"
      id="{{ baseId }}-warning-text-last-name"
      class="incorrect-input"
      translate
    >
      {{ lastNameControl.errors | fcListValidation : 'Last Name' }}
    </div>
  </div>

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-suffix"
      translate
    >Suffix</label>
    <input
      id="{{ baseId }}-suffix"
      class="form-control"
      [ngClass]="{ error: showErrors(suffixControl, isSubmitted), 'required': isRequired(suffixControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.Suffix.MaxLength"
      formControlName="suffix"
    />
    <div
      *ngIf="showErrors(suffixControl, isSubmitted)"
      id="{{ baseId }}-warning-text-suffix"
      class="incorrect-input"
      translate
    >
      {{ suffixControl.errors | fcListValidation : 'Suffix' }}
    </div>
  </div>

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-maiden-name"
      translate
    >Maiden Name</label>
    <input
      id="{{ baseId }}-maiden-name"
      class="form-control"
      [ngClass]="{ error: showErrors(maidenNameControl, isSubmitted), 'required': isRequired(maidenNameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.MaidenName?.MaxLength"
      formControlName="maidenName"
    />
    <div
      *ngIf="showErrors(maidenNameControl, isSubmitted)"
      id="{{ baseId }}-warning-text-maiden-name"
      class="incorrect-input"
      translate
    >
      {{ maidenNameControl.errors | fcListValidation : 'Maiden Name' }}
    </div>
  </div>

  <!-- Pronoun FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-pronoun">Pronoun</label>
    <ap-findcontrol
      id="{{ baseId }}-pronoun"
      controlName="pronounUid"
      findControlDisplayName="Find Pronoun"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListPronoun"
      [selectedPks]="pronounUidControl.value"
      (dirty)="pronounUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Pronoun FindControl -->

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-aka-first-name"
      translate
    >AKA First Name</label>
    <input
      id="{{ baseId }}-aka-first-name"
      class="form-control"
      [ngClass]="{ error: showErrors(akaFirstNameControl, isSubmitted), 'required': isRequired(akaFirstNameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.AkaFirstName.MaxLength"
      formControlName="akaFirstName"
    />
    <div
      *ngIf="showErrors(akaFirstNameControl, isSubmitted)"
      id="{{ baseId }}-warning-text-aka-first-name"
      class="incorrect-input"
      translate
    >
      {{ akaFirstNameControl.errors | fcListValidation : 'AKA First Name' }}
    </div>
  </div>

  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-last-name"
      translate
    >AKA Last Name</label>
    <input
      id="{{ baseId }}-last-name"
      class="form-control"
      [ngClass]="{ error: showErrors(akaLastNameControl, isSubmitted), 'required': isRequired(akaLastNameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.AkaLastName.MaxLength"
      formControlName="akaLastName"
    />
    <div
      *ngIf="showErrors(akaLastNameControl, isSubmitted)"
      id="{{ baseId }}-warning-text-aka-last-name"
      class="incorrect-input"
      translate
    >
      {{ akaLastNameControl.errors | fcListValidation : 'AKA Last Name' }}
    </div>
  </div>
</section>
